<!-- Tab Nav -->
<section id="anchorNav" class="tab-nav">
    <div class="clearfix content-wrapper">
        <a (click)="this.scrollToElement(link.fragment, $event)" class="tab-nav__link {{link.href}}-link scroll" [attr.data-cta]="link.title" *ngFor="let link of links" id="nav{{link.fragment}}">
            <h3 class="tab-nav__title">{{ link.title }} <img src="assets/img/downarrow.svg" /></h3>
            <h3 class="tab-nav__title--mob">{{ link.mobTitle }}</h3>
        </a>
    </div>
  </section>
  <!-- /Tab Nav -->